import {GetStaticProps, GetStaticPaths} from 'next';

import {Layout, SEOProps} from 'src/components';
import {CoachesPageTemplate} from 'src/components/coaches-page/CoachesPageTemplate';
import {regionalConfigsArr} from 'src/config';
import {PageParams} from 'src/types';

export const getStaticPaths: GetStaticPaths<PageParams> = async () => {
  const paths: {params: PageParams}[] = [];

  for (const config of regionalConfigsArr) {
    const {locales, regionCode: region} = config;
    for (const locale of locales) {
      paths.push({params: {region, locale}});
    }
  }

  return {paths, fallback: false};
};

export const getStaticProps: GetStaticProps<PageParams, PageParams> = async (
  ctx
) => {
  const {params} = ctx;

  if (!params) {
    throw new Error('Could not find URL Page params for coaches page');
  }

  const {region, locale} = params;

  return {
    props: {
      region,
      locale,
    },
  };
};

const CoachesPage: React.FC<React.PropsWithChildren<PageParams>> = (props) => {
  const {region, locale} = props;

  const seo: SEOProps = {
    title: {id: 'coaches.seoTitle', defaultMessage: 'Coaches'},
    description: {
      id: 'coaches.seoDescription',
      defaultMessage: 'Stryd Power Coaching Page',
    },
    noIndex: false,
    includeInRegions: ['all'],
    slug: 'coaches',
    slugPrefix: '',
  };

  return (
    <Layout seo={seo} pageContext={{region, locale}}>
      <CoachesPageTemplate />
    </Layout>
  );
};

export default CoachesPage;
